import { LazyPage, PipelineAddDestinationOptionPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineAddDestinationOptionRoute() {
  return (
    <LazyPage>
      <PipelineAddDestinationOptionPage />
    </LazyPage>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/add_/$destinationOptionId',
)({
  component: PipelineAddDestinationOptionRoute,
});
